export function getByteSize(str: string): number {
  return Buffer.from(str).byteLength;
}
